module.exports = __webpack_public_path__ + "static/media/TheFutureIsNow3.c3712d5c.png";